export default __webpack_public_path__ + "static/media/screenShareNew.7c9db6d1.svg";